import React, { Component } from 'react'
import { connect } from 'react-redux'
import { tagFunnel } from '../actions/tagmanager'
import { DispatchThunk } from '../actions/types'
import { convertToFile } from '../actions/upload'
import Button from '../components/base/Button'
import { CHECK_MY_PAPER, TEXT_FIELD } from '../util/dataTestIds'
import { textarea, button } from './DocumentTextarea.css'
import commonStyles from './App.css'

interface DocumentDispatchProps {
  handleCreateText: (...args: any[]) => any
}

interface DocumentStateProps {
  initialized: boolean
}

interface DocumentTextState {
  text: string
}

export type DocumentTextProps = DocumentStateProps & DocumentDispatchProps

export class DocumentText extends Component<DocumentTextProps, DocumentTextState> {
  constructor(props: DocumentTextProps) {
    super(props)
    this.state = { text: '' }
  }
  handleTextChange(text: string) {
    this.setState({ text })
  }

  render() {
    return (
      <>
        <label className={commonStyles.visuallyHidden} htmlFor="paste-paper-text-area">
          Paste your paper
        </label>
        <textarea
          id="paste-paper-text-area"
          className={textarea}
          onChange={e => this.handleTextChange(e.target.value)}
          rows={15}
          placeholder="Paste your paper here!"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          data-test-id={TEXT_FIELD}
        />
        <Button
          className={button}
          onClick={() => {
            this.props.handleCreateText(this.state.text)
          }}
          disabled={this.state.text.trim().length < 50 || !this.props.initialized}
          fullWidth
          data-id="checkPaperButton"
          data-test-id={CHECK_MY_PAPER}
          type="submit"
        >
          Check my paper
        </Button>
      </>
    )
  }
}
const mapStateToProps = (state: any) => ({
  initialized: state.app.initialized,
})
const mapDispatchToProps = (dispatch: DispatchThunk) => ({
  handleCreateText: (text: string) => {
    dispatch(convertToFile(text))
    dispatch(tagFunnel('upload paper', 'copy and paste'))
  },
})
export default connect<DocumentStateProps, DocumentDispatchProps>(mapStateToProps, mapDispatchToProps)(DocumentText)
